import {isNullOrUndefined} from "../../../../services/Validator";

export default function FlashCorrectionContentLayout({children}) {
    // Used in FlashCorrectionScreen to frame content in
    // both desktop and tablet mode

    // BUILD
    if (isNullOrUndefined(children))
        return null;
    return (
        <div className={"bg-backgroundLight3 w-[536px] md:w-[672px] lg:w-[928px] grow flex flex-col justify-start items-center px-[24px] pb-[24px]"}>
            {children}
        </div>
    );
}